import ContinuePage from "@components/ContinuePage"

export default function LooksmaxxingStyleProfilePage() {
  return <ContinuePage emoji="✨" translationKey="styleProfileLooksmaxxing" />
}
